<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar :dense="true" >
        <v-toolbar-title> <v-icon>mdi-account-card-details</v-icon> Driver Details </v-toolbar-title>
        <v-spacer />
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-card-text v-if="mode === 'loading'">
        <v-layout row wrap>
          <v-progress-linear indeterminate />
        </v-layout>
      </v-card-text>
      <v-card-text v-if="mode === 'form'" style="overflow-x: hidden">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.insdClmRefNo"
              v-model="clmMtrDrvr.insdClmRefNo"
              :error-messages="errors.collect('insdClmRefNo')"
              v-validate="'max:20'"
              data-vv-name="insdClmRefNo"
              :data-vv-as="labels.insdClmRefNo"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.drvIcNo"
              v-model="clmMtrDrvr.drvIcNo"
              :error-messages="errors.collect('drvIcNo')"
              v-validate="'max:20'"
              data-vv-name="drvIcNo"
              :data-vv-as="labels.drvIcNo"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="labels.drvName"
              v-model="clmMtrDrvr.drvName"
              :error-messages="errors.collect('drvName')"
              v-validate="'max:60'"
              data-vv-name="drvName"
              :data-vv-as="labels.drvName"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="labels.addr1"
              v-model="clmMtrDrvr.addr1"
              :error-messages="errors.collect('addr1')"
              v-validate="'max:60'"
              data-vv-name="addr1"
              :data-vv-as="labels.addr1"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="labels.addr2"
              v-model="clmMtrDrvr.addr2"
              :error-messages="errors.collect('addr2')"
              v-validate="'max:60'"
              data-vv-name="addr2"
              :data-vv-as="labels.addr2"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="labels.addr3"
              v-model="clmMtrDrvr.addr3"
              :error-messages="errors.collect('addr3')"
              v-validate="'max:60'"
              data-vv-name="addr3"
              :data-vv-as="labels.addr3"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.addr4"
              v-model="clmMtrDrvr.addr4"
              :error-messages="errors.collect('addr4')"
              v-validate="'max:60'"
              data-vv-name="addr4"
              :data-vv-as="labels.addr4"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.postCode"
              v-model="clmMtrDrvr.postCode"
              @change="checkAddress"
              :error-messages="errors.collect('postCode')"
              v-validate="'max:8'"
              data-vv-name="postCode"
              :data-vv-as="labels.postCode"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.telNo1"
              v-model="clmMtrDrvr.telNo1"
              :error-messages="errors.collect('telNo1')"
              v-validate="'max:20'"
              data-vv-name="telNo1"
              :data-vv-as="labels.telNo1"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.telNo2"
              v-model="clmMtrDrvr.telNo2"
              :error-messages="errors.collect('telNo2')"
              v-validate="'max:20'"
              data-vv-name="telNo2"
              :data-vv-as="labels.telNo2"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              v-model="clmMtrDrvr.drvGender"
              :label="labels.drvGender"
              :items="genderList"
              item-text="label"
              item-value="value"
              data-vv-name="drvGender"
              :error-messages="errors.collect('drvGender')"
              :data-vv-as="labels.drvGender"
            />
          </v-flex>
          <v-flex xs12 sm3>
            <cal-picker v-model="clmMtrDrvr.drvDob" :label="labels.drvDob" :data-vv-as="labels.drvDob" data-vv-name="drvDob" @blur="calculateAge" />
          </v-flex>
          <v-flex xs12 sm3>
            <v-subheader class="queryLabel">{{ labels.drvAge }}&nbsp;&nbsp;</v-subheader>
            <span>{{ clmMtrDrvr.drvAge }}</span>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.drvLicType"
              v-model="clmMtrDrvr.drvLicType"
              :error-messages="errors.collect('drvLicType')"
              v-validate="'max:16'"
              data-vv-name="drvLicType"
              :data-vv-as="labels.drvLicType"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <cal-picker
              v-model="clmMtrDrvr.drvLicExpDate"
              :label="labels.drvLicExpDate"
              :data-vv-as="labels.drvLicExpDate"
              data-vv-name="drvLicExpDate"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              :label="labels.fault1"
              v-model="clmMtrDrvr.fault1"
              :error-messages="errors.collect('fault1')"
              v-validate="'max:1'"
              data-vv-name="fault1"
              :data-vv-as="labels.fault1"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click.native="doSetToInsured" :loading="saving">Set Insured As Driver</v-btn>
        <v-btn color="primary" text @click.native="doValidate" :loading="saving">Save</v-btn>
        <v-btn color="red darken-1" text @click.native="doClose" :loading="saving">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { formatDisplayDate, yearDiff } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
export default {
  props: {},
  data() {
    return {
      mode: 'loading',
      saving: false,
      labels: {
        insdClmRefNo: 'Insured Claim Reference',
        drvIcNo: 'NRIC No.',
        drvName: 'Name',
        addr1: 'Address',
        addr2: 'Address (2)',
        addr3: 'Address (3)',
        addr4: 'Address (4)',
        postCode: 'Post Code',
        telNo1: 'Telephone No.',
        telNo2: 'Mobile No.',
        drvGender: 'Gender',
        drvDob: 'Date of Birth',
        drvAge: 'Age',
        drvLicType: 'License Type',
        drvLicExpDate: 'Licenes Expiry Date',
        fault1: 'Fault 1'
      },
      clmMtrDrvr: {
        insdClmRefNo: undefined,
        drvIcNo: undefined,
        drvName: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        postCode: undefined,
        telNo1: undefined,
        telNo2: undefined,
        drvGender: undefined,
        drvDob: undefined,
        drvAge: 0,
        drvLicType: undefined,
        drvLicExpDate: undefined,
        fault1: undefined
      },
      insured: {},
      genderList: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' }
      ]
    }
  },
  mounted() {
    this.sortDesc = [true]
    this.doFetch()
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      const apiUrl = this.$store.state.claims.claimDetail.menu.clmMtrDrvr
      if (apiUrl) {
        this.loading = true
        const result = await this.$http.get(expandURI(apiUrl, { clmNo: this.commonInfo.clmNo }))
        if (result && result.data) {
          const data = result.data
          if (data.data.clmMtrDrvr) {
            const clmMtrDrvr = data.data.clmMtrDrvr
            this.clmMtrDrvr = clmMtrDrvr
            this.clmMtrDrvr.drvDob = new Date(this.clmMtrDrvr.drvDob)
            this.clmMtrDrvr.drvLicExpDate = new Date(this.clmMtrDrvr.drvLicExpDate)
            this.calculateAge()
          }
          this.insured = data.data.insured
          this.mode = 'form'
        } else {
          this.$toast.error('Unexpected server response')
        }
      } else {
        this.$toast.error('Missing API URL (fetch Claim Motor Driver)')
      }
      this.loading = false
    },
    async checkAddress() {
      if (!this.clmMtrDrvr.postCode) {
        return
      }
      const apiUrl = this.$store.state.commons.menu.address
      if (apiUrl) {
        try {
          const expand = {
            postCode: this.clmMtrDrvr.postCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.clmMtrDrvr.addr1 = data.add1
            this.clmMtrDrvr.addr3 = data.add2
            this.clmMtrDrvr.addr4 = data.add4
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doValidate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doSave()
        }
      })
    },
    async doSave() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.clmMtrDrvrSave
      if (apiUrl) {
        this.saving = true
        try {
          this.clmMtrDrvr.clmNo = this.commonInfo.clmNo
          const result = await this.$http.post(apiUrl, this.clmMtrDrvr)
          if (result && result.data) {
            this.notify(result.data)
          } else {
            this.$toast.error('Unexpected server response')
          }
          this.saving = false
        } catch (err) {
          this.saving = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('missing apiUrl (claim motor driver save)')
      }
    },
    doSetToInsured() {
      this.clmMtrDrvr.drvName = this.insured.drvName
      this.clmMtrDrvr.insdClmRefNo = this.insured.insdClmRefNo
      this.clmMtrDrvr.drvIcNo = this.insured.drvIcNo
      this.clmMtrDrvr.drvName = this.insured.drvName
      this.clmMtrDrvr.addr1 = this.insured.addr1
      this.clmMtrDrvr.addr2 = this.insured.addr2
      this.clmMtrDrvr.addr3 = this.insured.addr3
      this.clmMtrDrvr.addr4 = this.insured.addr4
      this.clmMtrDrvr.postCode = this.insured.postCode
      this.clmMtrDrvr.telNo1 = this.insured.telNo1
      this.clmMtrDrvr.telNo2 = this.insured.telNo2
      this.clmMtrDrvr.drvGender = this.insured.drvGender
      this.clmMtrDrvr.drvDob = new Date(this.insured.drvDob)
      this.calculateAge()
      this.mode = 'form'
    },
    calculateAge() {
      this.clmMtrDrvr.drvAge = yearDiff(new Date(), this.clmMtrDrvr.drvDob)
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    },
    formatDisplayNumber(value, scale) {
      return formatDisplayNumber(value, scale)
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    },
    yearDiff(date1, date2) {
      return yearDiff(date1, date2)
    },
    doClose() {
      this.doFetch() // reset
      this.$emit('close')
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doFetch()
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style>
</style>
